import React from "react";
import { useTranslation } from "react-i18next";

function CardListHeader(props){
    const { t } = useTranslation()
    const { flexColumnStyles } = props

    return (
        <div className="listCardHeader" style={{padding: "0 15px"}}>
            <div
                className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                style={{flex:flexColumnStyles[0], textAlign:"center"}}
            >
                {t("ID da ocorrência")}
            </div>
            <div
                className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                style={{flex:flexColumnStyles[1], textAlign:"center"}}
            >
                {t("Lote de Comunicação")}
            </div>
            <div
                className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                style={{flex:flexColumnStyles[2], textAlign:"center"}}
            >
                {t("Data da Criação")}
            </div>
            <div
                className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                style={{flex:flexColumnStyles[3], textAlign:"center"}}
            >
                {t("Ações")}
            </div>
        </div>
    )
}

export default CardListHeader